import {api, apiGateway} from "../config";
import {IProductsRequest} from "./sellerProductsService";
import {AxiosPromise} from "axios";

class stocksService {

    findStocksForWarehouse(uuid: string) {
        return api(`${apiGateway.stocks}/stocks/for-warehouse/${uuid}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache"
            }
        })
    }

    getStocksAsXlsx(sellerID: number, userUUID: string, isExportOnlyEditable?: boolean, isExportOnlyFBO?: boolean) {
        return api(`${apiGateway.stocks}/stocks/for-seller/xlsx/${sellerID}/${userUUID}` + (isExportOnlyEditable ? '?isExportOnlyEditable=true' : '') + (isExportOnlyFBO ? '?isExportOnlyFBO=true' : ''), {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache"
            }
        })
    }

    getStocksForSeller<T>(data: IProductsRequest): AxiosPromise {
        return api(`${apiGateway.legacyPublicAPIv2}/stocks/get`, {
            method: "POST",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    async setStockToProductAtWarehouse<T>(sellerID: number, productID: number, warehouseID: string, quantity: number) {
        console.log('set stock жиесть', sellerID, productID, warehouseID, quantity);

        return api(`${apiGateway.stocks}/stocks`, {
            method: "POST",
            headers: {
                Accept:         "application/json",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify({
                sellerID:       sellerID,
                warehouseID:    warehouseID,
                productID:      productID,
                quantity:       +quantity,
                reason:         "Set stock by user over web tool",
                reason_quantity: +quantity,
                initiator:      "user",
            })
        })
    }

    async unsetStockOfProductAtWarehouse<T>(sellerID: number, productID: number, warehouseID: string) {
        console.log('unset stock жиесть', sellerID, productID, warehouseID,);

        return api(`${apiGateway.stocks}/unlink-product-with-warehouse`, {
            method: "DELETE",
            headers: {
                Accept:         "application/json",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify({
                sellerID:       sellerID,
                warehouseID:    warehouseID,
                productID:      productID
            })
        })
    }

    getFBOIdsByFilter(sellerID: number, filter?: object): AxiosPromise {
        return api(`${apiGateway.legacyPublicAPIv2}/stocks/ids-by-filter`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: { sellerID, channels: ["system"], filter },
        })
    }

    bulkUpdateStocks(
        sellerID: number,
        items: Array<{
            productID: number;
            warehouseID: string;
            quantity: number;
            reason_quantity?: number;
        }>,
        options: { initiator?: string; reason?: string } = {},
    ): AxiosPromise<{ data: { processed: number } }> {
        return api(`${apiGateway.stocks}/stocks/bulk`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            data: { sellerID, ...options, items },
        })
    }

    async setStocksForSellerByXlsx<T>(sellerID: number, file: File) {
        console.log('qwer3')
        const formData = new FormData();
        formData.append("file", file);

        return api(`${apiGateway.stocks}/stocks/set/for-seller/xlsx/${sellerID}`, {
            method: "POST",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
    }

}

export default new stocksService();